import React, { useState } from "react";
import AdminIDERequests from "./AdminIDERequests";
import AdminPages from "./AdminPages";
import AdminContentManager from "./AdminContentManager";
import LabManager from "../../components/LabManager";
import ProgramManager from "../program/ProgramManager";

export default function AdminDashboard() {
  const [tab, setTab] = useState("ide");
  const tabs = ["ide", "pages", "content", "labs", "programs"];

  return (
    <div className="container mt-4">
      <div className="mb-3">
        {tabs.map(t => (
          <button
            key={t}
            className={`btn me-2 ${tab === t ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setTab(t)}
          >
            {t.toUpperCase()}
          </button>
        ))}
      </div>

      {tab === "ide" && <AdminIDERequests />}
      {tab === "pages" && <AdminPages />}
      {tab === "content" && <AdminContentManager />}
      {tab === "labs" && <LabManager />}
      {tab === "programs" && <ProgramManager />}
    </div>
  );
}
